import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

class EuiTruncatePipe {
    transform(value, limit = 40, trail = '\u2026') {
        if (value) {
            if (limit < 0) {
                limit *= -1;
                return value.length > limit ? trail + value.substring(value.length - limit, value.length) : value;
            }
            else {
                return value.length > limit ? value.substring(0, limit) + trail : value;
            }
        }
        return;
    }
}
/** @nocollapse */ EuiTruncatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiTruncatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ EuiTruncatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiTruncatePipe, name: "euiTruncate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiTruncatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'euiTruncate',
                }]
        }] });
class EuiTruncatePipeModule {
}
/** @nocollapse */ EuiTruncatePipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiTruncatePipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiTruncatePipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiTruncatePipeModule, declarations: [EuiTruncatePipe], imports: [CommonModule], exports: [EuiTruncatePipe] });
/** @nocollapse */ EuiTruncatePipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiTruncatePipeModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiTruncatePipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [EuiTruncatePipe],
                    declarations: [EuiTruncatePipe],
                }]
        }] });

class EuiCoerceBooleanPipe {
    transform(value) {
        return coerceBooleanProperty(value);
    }
}
/** @nocollapse */ EuiCoerceBooleanPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiCoerceBooleanPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ EuiCoerceBooleanPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiCoerceBooleanPipe, name: "coerceBool" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiCoerceBooleanPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'coerceBool',
                    pure: true,
                }]
        }] });
class EuiCoerceBooleanPipeModule {
}
/** @nocollapse */ EuiCoerceBooleanPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiCoerceBooleanPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiCoerceBooleanPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiCoerceBooleanPipeModule, declarations: [EuiCoerceBooleanPipe], imports: [CommonModule], exports: [EuiCoerceBooleanPipe] });
/** @nocollapse */ EuiCoerceBooleanPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiCoerceBooleanPipeModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiCoerceBooleanPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [EuiCoerceBooleanPipe],
                    declarations: [EuiCoerceBooleanPipe],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EuiCoerceBooleanPipe, EuiCoerceBooleanPipeModule, EuiTruncatePipe, EuiTruncatePipeModule };
